<template>
	<div class="main">
	<el-container style="height:100%;" direction="vertical">
		  <el-main>
	
		
		<el-row   :gutter="20" >	
				<el-cascader-panel :options="options" ref="cascaderTizu" @change="handleTizuChange"  @expand-change="cascaderChange" v-model="cascagerdefault" ></el-cascader-panel>
		</el-row>
	
	
		<el-row   :gutter="24" > 
			
			<el-col :span="6"><div class="grid-content "><el-button @click="jindu()" :disabled="is_jindu_disable" type="primary" icon="el-icon-edit">进度</el-button></div></el-col>
	
			   <el-col :span="6"><div class="grid-content "><el-button @click="yuejuan()" :disabled="is_disable" type="primary" icon="el-icon-edit">阅卷</el-button></div></el-col>
	
		</el-row>
	
	
	
	  </el-main>
				
		</el-container>
	</div>
	
	
	
	</template>
	
	<script>
	export default {
		data() {
		  return {
			data: [],
			defaultProps: {
			   children: 'children',
						label: 'label',
						level: 'level'
					},
				sel_xm:'',
				sel_sb:'',
				sel_tizu:'',
				is_disable:true,
				is_jindu_disable:true,
				options:[],
				cascagerdefault: ["0", "0", ""]
				
		  };
		},
	
		mounted:function(){
			 
	
			  this.getopt();//需要触发的函数
		},
		
	
		methods: {
		
	
			
			cascaderChange(val) {
				console.log(val)
				if (val.length==3)
				{
					this.is_disable=false;
				}
				else
				{
					this.is_disable=true;
				}
	
	
				if (val.length==2&&val.length!=3)
				{
					this.is_jindu_disable=false;
					this.sel_xm=val[0];
					this.sel_sb=val[1];
				}
				else
				{
					this.is_jindu_disable=true;
				}
	
				
			},
	
			handleTizuChange(val){
					console.log(val)
					this.$refs['cascaderTizu'].getCheckedNodes()[0].pathLabels
					console.log(this.$refs['cascaderTizu'].getCheckedNodes()[0].pathLabels)
					this.sel_xm=val[0];
					this.sel_sb=val[1];
					this.sel_tizu=val[2];
					this.is_disable=false;
					this.is_jindu_disable=false;
					
	
				},
	
			handleNodeClick(data) {
				console.log(data);
				console.log(this.$refs.tree.getCurrentNode().label);
	
						console.log(this.$refs.tree.getCurrentNode().label_xm);
						let  tmpLabelXm = undefined;
						tmpLabelXm=this.$refs.tree.getCurrentNode().label_xm;
						if (typeof(tmpLabelXm) != "undefined")
						{
										this.sel_xm=this.$refs.tree.getCurrentNode().label_xm;
										this.sel_sb=this.$refs.tree.getCurrentNode().label_sb;
										this.sel_tizu=this.$refs.tree.getCurrentNode().label;
										this.is_disable=false;
						}
						else
						{	
										this.is_disable=true;
						}
					
				
			},
			getopt(){
		
					console.log('请求开始');
					//发送get请求
					this.$http.get('/yj?op=tizuInfo').then(function(res){
				
									console.log(res.body);
									this.data=res.body;
									this.options=res.body;
	
										this.cascagerdefault = [
										res.body[0].label,
										this.options[0].children[0].label,
										this.options[0].children[0].children[0].label
									];
	
								if (res.body[0].label!=undefined&&this.options[0].children[0].label!=undefined&&this.options[0].children[0].children[0].label!=undefined)
								{
									this.sel_xm=res.body[0].label;
									this.sel_sb=this.options[0].children[0].label;
									this.sel_tizu=this.options[0].children[0].children[0].label;
									this.is_disable=false;
									this.is_jindu_disable=false;
								}
									
					  console.log('请求结束');
			
					},function(){
						console.log('请求失败处理');
					});
			},
	
			selTizu(){
								//	alert(this.sel_xm+this.sel_sb+this.sel_tizu);
								this.$http.post('/yj?op=selTizu','xm='+this.sel_xm+'&subject='+this.sel_sb+'&tizu='+this.sel_tizu).then(function(response){
					
							//	this.loginmsg=res.body;
											return response.json();
								
									}).then(function(json){
			
										//	 alert(json.max_score);
										//获取题组相关信息  最大分值 步长等信息
								})    
				
			},
			yuejuan(){	
			
						//this.selTizu();						
						this.$router.push({ path: '/yjmain', query: { xm: this.sel_xm,subject: this.sel_sb,tizu:this.sel_tizu }});
			},
			jindu(){
	 
				this.$router.push({ path: '/dankejindu', query: { xm: this.sel_xm,subject: this.sel_sb,tizu:this.sel_tizu }});			
				
			},
			baobiao(){
	 
				this.$router.push({ path: '/page1', query: { xm: this.sel_xm,subject: this.sel_sb,tizu:this.sel_tizu }});			
				
			},
	
		}
	  };
	</script>
	
	<!-- Add "scoped" attribute to limit CSS to this component only -->
	<style scoped>
		html,
		body,
		#app,
		.main,
		.el-container {
			padding: 0px;
			margin: 0px;
			height: 100%;
	
		}
	
	  .el-tree{
		background: #f0f9eb;
	  }
	
	  .el-cascader-menu {
	  height: 300px;
	}
	
	.el-cascader-panel {
	  height:auto;
	}
	
	.mainbody {
	 
	   min-height: 100%;
	}
	
	.el-row {
		margin-bottom: 20px;
		&:last-child {
		  margin-bottom: 0;
		}
	  }
	  .el-col {
		border-radius: 4px;
	  }
	
	  .grid-content {
		border-radius: 4px;
		min-height: 36px;
	  }
	  .row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	  }
	
	</style>
	